import { RequestChangeEmailAddressMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const requestChangeEmailAddressHandler =
  graphql.mutation<RequestChangeEmailAddressMutation>(
    "requestChangeEmailAddress",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          requestChangeEmailAddress: {
            result: true,
          },
        },
      });
    }
  );
